import React, { useState } from 'react';
import { ChatStartersSectionContainer, ChatStartersContainer, ChatStarterInputWrapper, ChatStarterInput } from '../ConfigPage.styled';
import { Typography, Icon } from '@ann/web-components';

const ChatStartersSection = ({ chatStarters, onAddStarter, onRemoveStarter }) => {
    const [newStarter, setNewStarter] = useState('');

    const handleAdd = () => {
        if (newStarter.trim()) {
            onAddStarter(newStarter.trim());
            setNewStarter('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleAdd();
        }
    };

    return (
        <ChatStartersSectionContainer>
            <Typography category="subtitle" weight="bold" color="title" size="medium">
                Chat Starters
            </Typography>

            <ChatStartersContainer>
                {chatStarters.map((starter, index) => (
                    <ChatStarterInputWrapper key={index}>
                        <ChatStarterInput
                            value={starter}
                            readOnly
                        />
                        <Icon
                            name="close"
                            size="medium"
                            onClick={() => onRemoveStarter(index)}
                            style={{ cursor: 'pointer' }}
                        />
                    </ChatStarterInputWrapper>
                ))}

                <ChatStarterInputWrapper>
                    <ChatStarterInput
                        placeholder="Enter a chat starter"
                        value={newStarter}
                        onChange={(e) => setNewStarter(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <Icon name="plus" size="medium" onClick={handleAdd} />
                </ChatStarterInputWrapper>
            </ChatStartersContainer>
        </ChatStartersSectionContainer>
    );
};

export default ChatStartersSection;
